export const apiDocs = [
  {
    title: "Add Contact",
    url: "/op/api/create-contact",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "wbm-auth-key": "provide auth key",
    },
    requestExample: `{
  "countryCode":"91",
  "phoneNo":"954321XXXX",
  "firstName":"",
  "lastName":"",
  "companyName":"Test Company"
}`,
  },
  {
    title: "Update Contact",
    url: "/op/update-contact",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "wbm-auth-key": "provide auth key",
    },
    requestExample: `{
  "contactId":1,
  "firstName":"first Name",
  "lastName":"Last name",
  "email":"abc@yopmail.com",
  "waOptIn":1,
  "isBlocked":0,
  "remarks":"Test Remarks",
  "companyName":"Test Company 1",
  "city":"",
  "country":"",
  "countryCode":"91",
  "phoneNumber":"954321XXXX"
}`,
  },
  {
    title: "Delete Contacts",
    url: "/op/delete-selected-contacts",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "wbm-auth-key": "provide auth key",
    },
    requestDetails: [
      "Delete multiple contacts by providing an array of phone numbers.",
    ],
    requestExample: `[
  {
    "countryCode":"91",
    "phoneNo":"954321XXXX"
  }
]`,
  },

  {
    title: "Get Message Templates",
    url: "/op/wab/get-wab-templates",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "wbm-auth-key": "provide auth key",
    },
  },
  {
    title: "Get Contact Headers",
    url: "/op/get-contact-headers",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "wbm-auth-key": "provide auth key",
    },
  },
  {
    title: "Upload Media",
    url: "/op/upload-media",
    method: "POST",
    headers: {
      "wbm-auth-key": "provide auth key",
    },
    requestDetails: ["media: Provide file"],
    requestExample: `Form Data:
Key: media, Value: file`,
    responseExample: `{
  "fileName":"8ec82f00-66f9-4f66-9296-67469be732f0.jpg",
  "fileMimeType":"image/jpeg",
  "fileExtension":"jpg"
}`,
  },
  {
    title: "Generate Template Parameters",
    url: "/op/wab/generate-template-parameters",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "wbm-auth-key": "provide auth key",
    },
    requestDetails: [
      "templateJSON: Template JSON received from WhatsApp",
      "fallbackValues: If a variable part is not defined in the database, fallback values will be used.",
    ],
    requestExample: `{
  "templateJSON": {
    "name":"test_body_template",
    "parameter_format":"POSITIONAL",
    "components":[{"type":"BODY","text":"test body {{1}} test","example":{"body_text":[["test"]]}}],
    "language":"en",
    "status":"APPROVED",
    "category":"MARKETING",
    "id":"8555796327848900"
  },
  "fallbackValues":["Shankar"]
}`,
    responseExample: `[
  {
    "type": "body",
    "parameters": [
      { "type": "text", "text": "Shankar" }
    ]
  }
]`,
  },

  {
    title: "Send Message Template to Individual",
    url: "/op/wab/send-wab-message-template",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "wbm-auth-key": "provide auth key",
    },
    requestDetails: [
      "phoneNumber: Recipient's number with country code",
      "countryCode: Country Code",
      "selectedTemplate: WhatsApp template JSON",
      "parametersToBeSent: Template parameters",
      "variableFields: JSON Array of selected fields",
    ],
    requestExample: `{
  "phoneNumber":"954321XXXX",
  "countryCode":"91",
  "selectedTemplate": {
    "name":"test_body_template",
    "parameter_format":"POSITIONAL",
    "components":[{"type":"BODY","text":"test body {{1}} test","example":{"body_text":[["test"]]}}],
    "language":"en",
    "status":"APPROVED",
    "category":"MARKETING",
    "id":"8555796327848900"
  },
  "parametersToBeSent":[{"type":"body","parameters":[{"type":"text","text":"test"}]}],
  "variableFields":["first_name_c"]
}`,
  },
  {
    title: "Send Group Message Campaign",
    url: "/op/wab/start-group-campaign",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "wbm-auth-key": "provide auth key",
    },
    requestDetails: [
      "selectedContactGroup: Group name or phone number",
      "selectedTemplate: Template JSON from WhatsApp",
      "parametersToBeSent: Pass response from Generate Template Parameters API",
      "selectedField: JSON Array of selected fields",
    ],
    requestExample: `{
  "selectedContactGroup": "test group 1",
  "selectedTemplate": {
    "name": "test_body_template",
    "parameter_format":"POSITIONAL",
    "components":[{"type":"BODY","text":"test body {{1}} test","example":{"body_text":[["test"]]}}],
    "language":"en",
    "status":"APPROVED",
    "category":"MARKETING",
    "id":"8555796327848900"
  },
  "parametersToBeSent": [{"type":"body","parameters":[{"type":"text","text":"test"}]}],
  "selectedField": ["first_name_c"]
}`,
  },
  {
    title: "Schedule Campaign",
    url: "/op/wab/schedule-group-campaign",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "wbm-auth-key": "provide auth key",
    },
    requestDetails: [
      "scheduleType: recurring, oneTime",
      "contactType: individual, group",
      "selectedContactGroup: Group name or phone number",
      "selectedTemplate: WhatsApp Template JSON",
      "parametersToBeSent: Template parameters",
      "selectedField: JSON Array of selected fields",
    ],
    requestExample: `{
  "selectedField": "",
  "scheduleName": "",
  "scheduleDescription": "",
  "scheduleType": "",
  "scheduledTime": "",
  "contactType": "",
  "selectedContactGroup": "",
  "selectedTemplate": "",
  "parametersToBeSent": ""
}`,
  },

  {
    title: "Send Direct Message",
    url: "/op/wab/send-message",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "wbm-auth-key": "provide auth key",
    },
    requestDetails: [
      "phoneNumber: Provide phone number with country code",
      "messageContent: Provide message content",
      "messageType: text",
    ],
    requestExample: `{
  "phoneNumber":"91954321XXXX",
  "messageContent":"Hello Sushil",
  "messageType":"text"
}`,
  },
  {
    title: "Send Direct Media Message",
    url: "/op/wab/send-media-message",
    method: "POST",
    headers: {
      "wbm-auth-key": "provide auth key",
    },
    requestDetails: [
      "sendTo: Provide phone number with country code",
      "filename: File name received from Upload Media API",
      "fileMimeType: MIME type received from Upload Media API",
      "fileExtension: File extension received from Upload Media API",
    ],
    requestExample: `Form Data:
Key: sendTo, Value: 91954321XXXX
Key: filename, Value: 8ec82f00-66f9-4f66-9296-67469be732f0.jpg
Key: fileMimeType, Value: image/jpeg
Key: fileExtension, Value: jpg`,
    responseExample: `{
  "message":"Message Sent Successfully"
}`,
  },
];
